// extracted by mini-css-extract-plugin
export var content = "_qu-1";
export var noScroll = "_qu-3";
export var paper = "_qu-0";
export var scrollable = "_qu-2";